import { render, staticRenderFns } from "./Dagbesteding.vue?vue&type=template&id=c7227196&scoped=true&"
import script from "./Dagbesteding.vue?vue&type=script&lang=js&"
export * from "./Dagbesteding.vue?vue&type=script&lang=js&"
import style0 from "./Dagbesteding.vue?vue&type=style&index=0&id=c7227196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7227196",
  null
  
)

export default component.exports